import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useEffect, useRef } from 'react';
import { useAddTutorialMutation } from '../../../util/api/useAddTutorial';
import { useTutorialsLocalStorage } from '../../../util/tutorials/useTutorialsLocalStorage';

export const PerformanceSettingsTutorialKey = 'performanceSettings';

type Props = {
  userId: string;
};

export default function PerformanceSettingsTutorial(props: Props) {
  const complete = useAddTutorialMutation(props.userId);
  const tutorialsStorage = useTutorialsLocalStorage();
  const driveRef = useRef<ReturnType<typeof driver> | undefined>(
    driver({
      showProgress: true,
      smoothScroll: false,
      overlayClickBehavior: 'nextStep',
      allowClose: true,
      onDestroyed: () => {
        tutorialsStorage.add(PerformanceSettingsTutorialKey);
        complete.mutate(PerformanceSettingsTutorialKey);
      },
      steps: [
        {
          element: '[aria-label="Performance Settings"]',
          popover: {
            title: 'Performance Settings',
            description: 'Beta features are ON by default. Turn them OFF here if something breaks.'
          }
        },
        {
          popover: {
            title: 'Database Running Slow?',
            description: 'Try these settings to boost performance. Report what you changed and what was slow.'
          }
        },
        {
          popover: {
            title: "That's It!",
            description: 'Beta ON = new features. Problems? Turn OFF and report.'
          }
        }
      ]
    })
  );

  useEffect(() => {
    driveRef.current?.drive();
  }, []);

  return <></>;
}
